import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// import { PersistGate } from "redux-persist/integration/react";
import { apiStore } from "./api/Store/Store";
import { SignalRProvider } from "./context/signalRContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={apiStore}>
    {/* <PersistGate loading={null} persistor={persistor}> */}
    <SignalRProvider>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </SignalRProvider>
    {/* </PersistGate> */}
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
